module.exports = __webpack_public_path__ + "static/img/nodata.c517646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/nodata.png
// module id = olMA
// module chunks = 3